export const ADD_FAVORITES = "ADD_FAVORITES";
export const DELETE_FAVORITES = "DELETE_FAVORITES";
export const FILTER = "FILTER";
export const ORDER = "ORDER";
export const RESET = "RESET";
export const ADD_CHARACTERS = "ADD_CHARACTERS";
export const DELETE_CHARACTERS = "DELETE_CHARACTERS";
